import Rate from './rate';
import Moderate from './moderate';
import KYC from './kyc';
import BuyModal from './buyCrypto';
import ModalAssetHeader from './header';
import AssetAverageScore from './averageScore';
import ForecastModal from './forecast';

export default {
  EmRate: Rate,
  EmModerate: Moderate,
  EmHeader: ModalAssetHeader,
  EmAssetAverageScore: AssetAverageScore,
  EmKYC: KYC,
  EmBuyCrypto: BuyModal,
  EmForecast: ForecastModal,
}



// WEBPACK FOOTER //
// ./src/components/modals/index.js